import {createStore} from 'vuex'
import subscription from './subscription'
import mailing from './mailing'

export default createStore({
    modules: {subscription, mailing},
})
